import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden auto',
    // Account for header and footer areas in mobile view
    height: ({ mobile }) => (mobile ? 'calc(100svh - 252px)' : 'unset'),
    maxHeight: ({ mobile }) => (mobile ? 'unset' : 'calc(100svh - 270px)'),

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.nearWhite
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },

  empty: {
    width: '100%',
    textAlign: 'center',
    paddingTop: '1rem',
    color: 'gray',
    whiteSpace: 'break-spaces'
  }
}))

export default useStyles
